// The account page's two URL helpers: the link into `/account`, and where its
// Back goes.
//
// The page Back returns to rides the URL as `?from=` rather than session
// storage, so it survives the full-page OAuth round trip a Connect makes (the
// server's `returnTo` keeps every query key but its own marker).

const FALLBACK = "/focus";

/** `/account` carrying the page the user came from. */
export const accountHref = (from: string): string =>
  `/account?${new URLSearchParams({ from }).toString()}`;

/**
 * Where Back goes: the `from` the link carried, only when it is one of the
 * two surfaces that link here (`/focus…`, `/projects…`). Anything else — a
 * missing value, another origin, a protocol-relative `//host`, a backslash a
 * browser may read as a slash — goes to the Focus picker.
 */
export const accountBackTarget = (raw: string | null): string => {
  if (raw === null || raw.includes("\\")) return FALLBACK;
  const ok =
    raw === "/focus" ||
    raw === "/projects" ||
    raw.startsWith("/focus/") ||
    raw.startsWith("/projects/");
  return ok ? raw : FALLBACK;
};
